export default "__VITE_PUBLIC_ASSET__418a573e__"